// components/Recommendations.jsx
import React from 'react';

export const Recommendations = ({ recommendations, widgetDetails, onSelect }) => {
  if (!recommendations || recommendations.length === 0) return null;

  return (
    <>
      <div className='chat-group d-flex flex-wrap align-items-center gap-2'>
        {recommendations?.map((recommendation, index) => (
          <button
            key={index}
            className='btn chat-group-btn'
            style={{
              background: `${widgetDetails?.color}`,
              color: `${widgetDetails?.agent_bubble_text_color}`,
              border: `2px solid ${widgetDetails?.client_bubble_color}`,
              fontSize: `${widgetDetails?.agent_bubble_font_size}px`,
              width: widgetDetails?.chatbot_slider_size <= 360 ? '100%' : 'unset',
            }}
            onClick={() => onSelect(recommendation?.answer)}
          >
            {recommendation?.answer}
          </button>
        ))}
      </div>

      <style>
        {`
          .chat-group-btn:hover {
            background: ${widgetDetails?.client_bubble_color} !important;
            color: ${widgetDetails?.bubble_text_color} !important; 
          }
        `}
      </style>
    </>
  );
};
